/* eslint-disable jsx-a11y/img-redundant-alt */
import { Box } from '@material-ui/core';
import React from 'react';

export const Loading = () => {
  return (
    <Box
      className='modal-container'
    >
      <span class="loader"></span>
    </Box>
  );
};
